export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exporter les sinistres"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un email contenant l'export vous sera envoyé une fois celui-ci prêt."])},
        "active_filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtres appliqués :"])},
        "no_filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun filtre sélectionné — tous les sinistres seront exportés."])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exporter"])},
        "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
        "export_success_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export lancé"])},
        "export_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'export sera envoyé par mail dès qu'il sera prêt."])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export claims"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An email with the export will be sent to you once it's ready."])},
        "active_filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Applied filters:"])},
        "no_filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No filters selected — all claims will be exported."])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export"])},
        "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
        "export_success_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export started"])},
        "export_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The export will be sent by email as soon as it's ready."])}
      }
    }
  })
}
